import { Dispatch } from "@reduxjs/toolkit";
import NoAuthPage from "../../pages/auth/NoAuthPage";
import { UNAUTHENTICATED_APP } from "../../store/mvision-client-list";
import { fetchClientList } from "../../store/reducers";
import { sleep } from "../../util/sleep";
import BackendApiInterface from "../backend-api-interface";

/**
 * Development-time convenience API wrapper that allows running ConfigUI without
 * attaching to any real backend. Instead, fake static API data is used instead.  
 * */
export default class DevStaticApi implements BackendApiInterface {

    public init(dispatch: Dispatch) {
        // we don't need to do login here, but we do need to fetch the client list
        dispatch(fetchClientList());
    }

    public async fetchModelConfigurationFileAsync(): Promise<any> {
        const modelConfigFileResponse = await fetch('./dev-data/config/modelConfig.json');
        if (modelConfigFileResponse.status !== 200) {
            console.error(modelConfigFileResponse);
            throw new Error(`Received response ${modelConfigFileResponse.status}`);
        }
        const responseData = await modelConfigFileResponse.json();
        return responseData;
    }

    public async saveModelConfigurationAsync(appClient: undefined, json: string): Promise<boolean> {
        console.log('saveModelConfigurationAsync called for following JSON:');
        console.log(json);
        await sleep(500);
        return true;
        // uncomment the line below to test a failing model config save case
        // throw new Error("dev error: failed to save model config");
    }

    public deleteModelConfigurationAsync(appClient: undefined | undefined): never { throw new Error("deleteModelConfigurationAsync not implemented for DevStaticApi"); }

    public async fetchLicenseStatusAsync(): Promise<any> {
        const response = await fetch('./dev-data/config/licensingStatus.json');
        if (response.status !== 200) {
            console.error(response);
            throw new Error(`Received response ${response.status}`);
        }
        const responseData = await response.json();
        return responseData;
    }

    public async saveLicenseAsync(appClient: undefined, newLicense: string): Promise<boolean> {
        await sleep(500);
        return true;
        // uncomment the line below to test a failing license update UI case
        // throw new Error("dev error: failed to save license");
    }

    public async fetchLabelingAsync(): Promise<any> {
        const response = await fetch('./dev-data/config/labeling.json');
        if (response.status !== 200) {
            console.error(response);
            throw new Error(`Received response ${response.status}`);
        }
        const responseData = await response.json();
        return responseData;
    }

    public async fetchClientListAsync(): Promise<any> {
        return [{
            'app_id': UNAUTHENTICATED_APP,
            'app_name': UNAUTHENTICATED_APP,
            'app_info': UNAUTHENTICATED_APP,
        }];
    }

    public async fetchAllDaemonConfigsAsync(): Promise<never> { throw new Error("fetchAllDaemonConfigsAsync not implemented for DevStaticApi"); }
    public async fetchDaemonConfigAsync(): Promise<never> { throw new Error("fetchDaemonConfigAsync not implemented for DevStaticApi"); }
    public async saveDaemonConfigAsync(): Promise<never> { throw new Error("saveDaemonConfigAsync not implemented for DevStaticApi"); }
    public async resetDaemonConfigAsync(): Promise<never> { throw new Error("resetDaemonConfigAsync not implemented for DevStaticApi"); }
    public async deleteDaemonConfigAsync(): Promise<never> { throw new Error("deleteDaemonConfigAsync not implemented for DevStaticApi"); }
    public async fetchActiveModelsAsync(): Promise<never> { throw new Error('fetchActiveModelsAsync not implemented for DevStaticApi'); }

    getAppWrapperComponent(): (props: React.PropsWithChildren<{}>) => JSX.Element {
        return NoAuthPage;
    }
}